import React from "react";
import Box from "@mui/material/Box";

const defaultStyles = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  justifyContent: "space-between",
  alignItems: { xs: "flex-start", sm: "center" },
  gap: 2,
  mb: 3,
};

function TitleActionsContainer({ sx, children }) {
  return <Box sx={{ ...defaultStyles, ...sx }}>{children}</Box>;
}

export default TitleActionsContainer;
